import { useTranslation } from "react-i18next";

const categories = [
  { key: "shoes", labelKey: "categories.shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { key: "hoodies", labelKey: "categories.hoodies", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { key: "tshirts", labelKey: "categories.tshirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { key: "jackets", labelKey: "categories.jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { key: "pants", labelKey: "categories.pants", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { key: "headwear", labelKey: "categories.headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { key: "sets", labelKey: "categories.sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { key: "underwear", labelKey: "categories.underwear", url: "https://kaspreadsheet.com/search-918/name/Shoes.html" },
  { key: "jersey", labelKey: "categories.jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
  { key: "accessories", labelKey: "categories.accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
  { key: "bags", labelKey: "categories.bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  { key: "belts", labelKey: "categories.belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
  { key: "perfumes", labelKey: "categories.perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
  { key: "other", labelKey: "categories.other", url: "https://kaspreadsheet.com/search-924/name/Shoes.html" },
];

export default function CategoryButtonsSection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            {t("categoryButtons.h2")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {t("categoryButtons.copy")}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300/50 hover:shadow-md transition-all text-center"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className="ri-shopping-bag-3-line text-lg md:text-xl" />
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-950 transition-colors leading-tight">
                {t(cat.labelKey)}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}